module.exports = __webpack_public_path__ + "static/media/marek_wolfryd_19.b387b36e.jpg";